<template>
    <router-view :key="$route.path"></router-view>
</template>

<script>
    export default {
        name:'Qna',
        created () {
            this.$store.state.headerTitle = '1:1 문의';
        },
    }
</script>

<style lang="scss" scoped>

</style>